import { ReactNode } from 'react';
import { PageLayout } from '@xtnd/web/shared/layout';
import { useReportFeatureEnabled } from '../../../hooks';

interface JuniperEmailLayoutProps {
  children: ReactNode;
}

export function JuniperEmailLayout({ children }: JuniperEmailLayoutProps) {
  const { isLoading, error, refetch, isReportingEnabled } = useReportFeatureEnabled();

  return (
    <PageLayout
      title="Juniper Email Tracking"
      description="Track Juniper email delivery health, diagnose recipient issues, and review send history across clients and matters."
      icon="HiMail"
      isLoading={isLoading}
      isDisabled={!isReportingEnabled}
      isError={!!error}
      errorState={{
        title: 'Failed to Load Report Configuration',
        description:
          error?.message ?? 'An unknown error occurred while loading the report configuration.',
        onRetry: () => refetch(),
      }}
      disabledState={{
        title: 'Juniper Email Tracking Disabled',
        description:
          'The reporting module is not enabled for this tenant. Please contact your administrator to enable reporting features.',
      }}
      skeletonProps={{
        summaryCardCount: 5,
        tableRows: 8,
        tableColumns: 6,
      }}
    >
      {children}
    </PageLayout>
  );
}
